import React from "react";
import {Button, Form, Input} from "reactstrap";
import TextLabel from "../../../../Controls/TextLabel.mjs";

const G = window.glob;

const CurrentChatForm = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { value: props.text ?? '' };
		this.onSubmit = this.onSubmit.bind(this);
		this.uid = G.generateUid('CurrentChatForm');
	}
	onSubmit( evt ) {
		try { evt.preventDefault() } catch (e) {}
		const txt = this.state.value;
		if ( txt ) this.props.send(txt);
		this.setState({ value: '' });
	}
	render() {
		return(
			<div className={"CurrentChatForm"} id={this.uid}>
				<Form onSubmit={this.onSubmit}>
					<div>
						<div>
							<Input
								autoFocus={true}
								value={this.state.value}
								onChange={ e => this.setState({value: e.target.value })}
								type="text"
								placeholder={G.label("Type a message…")}
							/>
						</div>
						<div>
							<Button
								type="submit"
								disabled={!this.state.value}
								className={"btn-icon"}
							>
								<i>
									<TextLabel value={"forward"} lang={"icon"}/>
								</i>
							</Button>
						</div>
					</div>
				</Form>
			</div>
		);
	}
}

export default CurrentChatForm;